import SubscriptionPlan, {
  SUBSCRIPTION_PLAN_ORDER,
  subscriptionPlanNameFragment,
} from "@app/enum/SubscriptionPlan";

// A legacy plan grants none of its tier's add-ons on the backend, so naming it here would
// both mislabel the org and suppress the bands it needs.
const isLegacyPlanName = (lowercaseName: string) => lowercaseName.includes("legacy");

// Most expensive first: a name that could match two tiers resolves to the higher one.
const MATCH_ORDER = [...SUBSCRIPTION_PLAN_ORDER].reverse();

const getCurrentSubscriptionPlan = (planName: string | undefined): SubscriptionPlan | undefined => {
  const lowercaseName = planName?.toLowerCase();
  if (!lowercaseName || isLegacyPlanName(lowercaseName)) {
    return undefined;
  }
  return MATCH_ORDER.find((plan) => lowercaseName.includes(subscriptionPlanNameFragment[plan]));
};

export default getCurrentSubscriptionPlan;
